import api from '@/network';

export interface MonoscaleTest {
    Uuid: string;
    TestName: string;
    TestTitle: string;
    TestLink: string | null;
    Cost: number;
}

export default {
    async getMonoscales(): Promise<MonoscaleTest[]> {
        const response = await api.get('battery/monoscales');
        return (response.data.data as MonoscaleTest[]) ?? [];
    },
};
